export function getErrorData({ errorType, errorMessage }) {
    let d = {
        message: "",
        internalMsg: errorType,
        redirect: null,
        eventAction: null,
        clearQueryParams: false,
    };

    switch (errorType) {
        case "validateAddress":
            d.message =
                "We couldnt verify your address. Please check and retry, or feel free to reach out to our support team for assistance. Click ok to continue.";
            d.redirect = { type: "name", path: "cart" };
            d.eventAction = "redirect";
            break;

        case "validateCart":
            d.message =
                "Unfortunately, one or more items in your cart are no longer available or your cart contains the same unique diamond attached to multiple items in your cart.";
            d.redirect = { type: "name", path: "cart" };
            d.eventAction = "redirect";
            break;

        case "getProducts":
            d.message =
                "Looks like your cart is empty. Please add products to your cart.";
            d.redirect = { type: "to", path: "/" };
            d.eventAction = "redirect";
            break;

        case "critical_error": 
            d.message = errorMessage;
            d.redirect = { type: "to", path: "/" };
            d.eventAction = "redirect";
            break;
        
        case "too_many_clone_attempts": 
            d.message = errorMessage;
            d.redirect = false;
            d.eventAction = "reload";
            break;

        case "getPaypalClientToken":
            d.message =
                "Error occurred while mounting gateway, please click ok to reload.";
            d.redirect = false;
            d.eventAction = "reload";
            break;

        case "getPaypalUserData":
            d.message =
                "Error occurred while mounting gateway, please click ok to reload.";
            d.redirect = false;
            d.eventAction = "reload";
            break;

        // card
        case "clientErr":
            d.message =
                "Error occurred while mounting gateway, please click ok to reload.";
            d.redirect = false;
            d.eventAction = "reload";
            break;

        case "transactionFailure":
            d.message =
                "We could not authorize your card, please try again with different card or use another payment method.";
            d.redirect = false;
            d.eventAction = "remount";
            break;

        case "transactionClosed":
            d.message =
                "Apologies, your last transaction was cancelled. Please try again.";
            d.redirect = false;
            d.eventAction = "remount";
            break;

        case "affirmValidationError":
            d.message = errorMessage;
            d.redirect = false;
            d.eventAction = "remount";
            break;

        case "achTransactionFailure":
            d.message =
                "Apologies, we could not process bank account verification. Please contact support if error persists.";
            d.redirect = false;
            d.eventAction = "remount";
            break;

        case "backendUserNotFound":
            d.message =
                "User Not Found: Please ensure you are logged in before making a purchase.";
            d.redirect = false;
            d.eventAction = "remount";
            break;

        case "backendBraintreeError":
            d.message = `Payment gateway response - ${errorMessage} `;
            d.redirect = false;
            d.eventAction = "remount";
            break;

        case "backendServerError":
            d.message = `There’s a problem communicating with the payment gateway used for this transaction. Please try again!  `;
            d.redirect = false;
            d.eventAction = "reload";
            break;

        case "requirePaymentMode":
            d.message = `Please select a payment method to proceed.`;
            d.redirect = false;
            d.eventAction = "";
            break;

        case "invalidCoupon":
            d.message = `The applied promo code is no longer valid. Kindly remove it or update the code to proceed`;
            d.redirect = false;
            d.eventAction = "reload";
            break;

        case "juspayError":
            d.message = `Apologies, your last transaction was cancelled. Please try again.`;
            d.redirect = false;
            d.eventAction = "reload";
            break;
        case "afterPayError":
            d.message = errorMessage;
            d.redirect = false;
            d.eventAction = "reload";
            break;
        case "createPlanError":
            d.message = errorMessage;
            d.redirect = false;
            d.eventAction = "reload";
            break;
        case "lookupError":
            d.message = errorMessage;
            d.redirect = false;
            d.eventAction = "reload";
            break;
        case "googlePayError":
            d.message = errorMessage;
            d.redirect = false;
            d.eventAction = "remount";
            break;
        case "stripeError":
            d.message = errorMessage;
            d.redirect = false;
            d.eventAction = "remount";
            break;
        case "klarna_stripe_error":
            d.message = errorMessage;
            d.redirect = false;
            d.eventAction = "reload";
            d.clearQueryParams = true;
            break;
        case "affirmStripeError":
            d.message = errorMessage;
            d.redirect = false;
            d.eventAction = "reload";
            d.clearQueryParams = true;
            break;
        case "validateCheckoutCartError":
            d.message = errorMessage;
            d.redirect = false;
            d.eventAction = "reload";
            break;
        case "500":
            d.message = errorMessage;
            d.redirect = false;
            d.eventAction = "reload";
            break;
        //
    }

    return d;

}

export function getMethodType(type) {
    let payment_type = false;
    if (type === "credit_card") {
        payment_type = 1;
    }

    if (type === "affirm") {
        payment_type = 8;
    }

    if (type === "afterpay") {
        payment_type = 13;
    }

    if (type === "telephone") {
        payment_type = 7;
    }
    if (type === "bankwire") {
        payment_type = 9;
    }
    if (type === "ach") {
        payment_type = 3;
    }
    if (type === "splitit") {
        payment_type = 5;
    }
    if (type === "paypal" || type === "paylater") {
        payment_type = 4;
    }
    if (type === "googlepay") {
        payment_type = 16;
    }
    if (type === "stripe_card") {
        payment_type = 24;
    }
    if (type === "affirm_stripe") {
        payment_type = 25;
    }
     if (type === "klarna_stripe") {
        payment_type = 26;
    }
    return payment_type;
}